<template>
  <div class="container">
     <!-- modales para diferentes estados de cognito -->
     <b-modal v-model="newPasswordModal" id="modal-1" title="Cambio de contraseña " hide-footer>
      <b-form>
        <b-alert v-if="newPasswordAlert" show variant="success">{{ newPasswordAlert }}</b-alert>
        <b-form-group label="Cambiar contraseña" :invalid-feedback="invalidPasswordFeedback()" :valid-feedback="validPasswordFeedback(newPassword)" :state="validatePassword(newPassword)">
          <b-form-input v-model="newPassword" id="reset_password" :type="!passwordHidden ? 'password':'text'" placeholder="Nueva contraseña" :state="validatePassword(newPassword)" trim></b-form-input>
          <span v-if="passwordHidden" class="display-eye fa fa-eye" @click="showPassword"></span>
          <span v-if="!passwordHidden" class="display-eye fa fa-eye-slash" @click="hidePassword"></span>
        </b-form-group>
        <b-button :disabled="!validatePassword(newPassword)" @click="resetPassword">Cambiar</b-button>
      </b-form>
    </b-modal>

    <b-modal v-model="newPasswordRequiredModal" title="Restablecer contraseña " hide-footer>
      <b-form>
          <h6>Para restablecer tu contraseña ingresa el código de verificación que recibiste en tu correo electrónico. Si no cuentas con uno regresa al paso 1, recuerda que puede demorar unos minutos en llegar.</h6>
         <b-form-group label="Correo electrónico" :invalid-feedback="invalidEmailFeedback()" :valid-feedback="validEmailFeedback(emailRequiredModal)" :state="validateEmail(emailRequiredModal)">
          <b-form-input v-model="emailRequiredModal" id="email-reset" placeholder="Correo electrónico" :state="validateEmail(emailRequiredModal)" trim></b-form-input>
        </b-form-group>

        <b-form-group label="Nueva contraseña" :invalid-feedback="invalidPasswordFeedback()" :valid-feedback="validPasswordFeedback(newPasswordRequired)" :state="validatePassword(newPasswordRequired)">
          <b-form-input v-model="newPasswordRequired" :type="!passwordHidden ? 'password':'text'" id="reset_password" placeholder="Nueva contraseña" :state="validatePassword(newPasswordRequired)" trim> </b-form-input>
          <span v-if="passwordHidden" class="display-eye fa fa-eye" @click="showPassword"></span>
          <span v-if="!passwordHidden" class="display-eye fa fa-eye-slash" @click="hidePassword"></span>
        </b-form-group>
        <b-form-group label="Código de verificación" :invalid-feedback="validCodeFeedback(confirmationCodeRequired)" :valid-feedback="validCodeFeedback(confirmationCodeRequired)" :state="validateCode(confirmationCodeRequired)">
          <b-form-input v-model="confirmationCodeRequired" id="reset_password_code" placeholder="Código de verificación" :state="validateCode(confirmationCodeRequired)" trim></b-form-input>
        </b-form-group>
          <b-button :disabled="loadingChangeRequired" type="button" variant="outline-dark" @click="resetPasswordRequired">
            Aceptar
            <span v-if="loadingChangeRequired" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          </b-button>
        <!--<b-button :disabled="!validateCode(confirmationCodeRequired) && !validatePassword(newPasswordRequired)" @click="resetPasswordRequired">Cambiar contraseña</b-button>-->
      </b-form>
    </b-modal>

    <b-modal v-model="confirmEmailModal" id="modal-1" title="Confirmar usuario" hide-footer>
      <b-form>
        <b-alert v-if="confirmUserError" show variant="danger">{{ confirmUserError }}</b-alert>
        <b-alert v-if="confirmUserAlert" show variant="success">{{ confirmUserAlert }}</b-alert>
        <b-form-group label-for='email_confirm'>
          <b-form-input id="email_confirm" :placeholder="'Nombre de usuario'" v-model="usernameConfirm" trim></b-form-input>
        </b-form-group>
        <b-form-group label-for="confirmationCode">
          <b-form-input id="confirmationCode" :placeholder="'Codigo de verificacion'" v-model="confirmationCode" trim></b-form-input>
        </b-form-group>
        <b-button :disabled="!(usernameConfirm && confirmationCode.length == 6)" @click="userConfirmation">Confirmar</b-button>
      </b-form>
    </b-modal>
    <b-modal v-model="confirmEmailModal" id="modal-1" title="Confirmar usuario" hide-footer>
      <b-form>
        <b-alert v-if="confirmUserError" show variant="danger">{{ confirmUserError }}</b-alert>
        <b-alert v-if="confirmUserAlert" show variant="success">{{ confirmUserAlert }}</b-alert>
        <b-form-group label-for='email_confirm'>
          <b-form-input id="email_confirm" :placeholder="'Nombre de usuario'" v-model="usernameConfirm" trim></b-form-input>
        </b-form-group>
        <b-form-group label-for="confirmationCode">
          <b-form-input id="confirmationCode" :placeholder="'Codigo de verificacion'" v-model="confirmationCode" trim></b-form-input>
        </b-form-group>
        <b-button :disabled="!(usernameConfirm && confirmationCode.length == 6)" @click="userConfirmation">Confirmar</b-button>
      </b-form>
    </b-modal>

    <b-modal v-model="resetPasswordModal" id="modal-1" title="Enviar código de verificación" hide-footer>
      <b-form>
        <b-alert v-if="confirmUserError" show variant="danger">{{ confirmUserError }}</b-alert>
        <b-alert v-if="confirmUserAlert" show variant="success">{{ confirmUserAlert }}</b-alert>
        <b-form-group label="Correo electrónico" :invalid-feedback="invalidEmailFeedback()" :valid-feedback="validEmailFeedback(resetPasswordEmail)" :state="validateEmail(resetPasswordEmail)">
          <b-form-input v-model="resetPasswordEmail" id="email-reset" placeholder="Correo electrónico" :state="validateEmail(resetPasswordEmail)" trim></b-form-input>
        </b-form-group>
        <b-button :disabled="!(resetPasswordEmail && validateEmail(resetPasswordEmail))" @click="resetUserPassword">Enviar</b-button>
      </b-form>
    </b-modal>
    <!-- modales para diferentes estados de cognito -->
    <div class="text-left mb-5">
      <h1 class="mb-5">
        <strong>Bienvenido al Portal <br/> de Concesionarios</strong>
      </h1>
    </div>
      <div class="text-dark font-size-24 mb-3">
        <strong>Inicio de Sesión</strong>
      </div>
       <b-form mb="4">
                <b-alert v-if="errorMessage" show variant="danger">{{ errorMessage }}</b-alert>
                <b-form-group label="Correo electrónico" label-for="email" :invalid-feedback="invalidEmailFeedback()" :valid-feedback="validEmailFeedback(email)" :state="validateEmail(email)">
                  <b-form-input id="email" placeholder="Correo electrónico" v-model="email" :state="validateEmail(email)" trim></b-form-input>
                </b-form-group>

                <b-form-group label="Contraseña" label-for="password" :invalid-feedback="invalidPasswordFeedback()" :valid-feedback="validPasswordFeedback(password)" :state="validatePassword(password)">
                  <b-form-input :type="!passwordLoginHidden ? 'password':'text'" id="password" placeholder="Contraseña" v-model="password" :state="validatePassword(password)" trim></b-form-input>
                  <span v-if="passwordLoginHidden" class="display-eye fa fa-eye" @click="showLoginPassword"></span>
                  <span v-if="!passwordLoginHidden" class="display-eye fa fa-eye-slash" @click="hideLoginPassword"></span>
                </b-form-group>

                <b-button :disabled="!acceptedTermsAndConditions || loading" type="button" variant="outline-dark" @click="signin">
                  Entrar
                  <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                </b-button>
                <div class="space"/><div class="space"/><div class="space"/>
                <div>
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="acceptedTermsAndConditions"
                    name="checkbox-1"
                    :value="true"
                    :unchecked-value="false"
                  >
                    Al seleccionar esta casilla acepto los <a class="text-blue" target="_blank" href="https://www.taxicontigo.com/terminos-y-condiciones-concesionario/">términos y condiciones </a> para el Portal de Concesionarios
                  </b-form-checkbox>
                </div>
                <div class="space"/><div class="space"/><div class="space"/>
                <div class="text-dark font-size-24 mb-3">
                  <strong>Restablecer contraseña</strong>
                </div>
                <p>
                  <a @click="resetPasswordModal=true">Paso 1: Enviar código de verificación</a>
                </p>
                <p>
                  <a @click="newPasswordRequiredModal=true">Paso 2: Restablecer contraseña</a>
                </p>
            </b-form>
  </div>
</template>
<script>
// import { encrypt } from '@/config/headers'
// import headers from '@/config/headers.js'
import { db } from '../../../../../services/firebase/index'
import gql from 'graphql-tag'
const GET_CONCESIONARIO_QUERY = gql`
query getConcesionarioId($id: Int){
  getConcesionarioId(id: $id){
    id
    name
    email
    phoneNumber
    rfc
  }
}
`
const CREATE_SESSION = gql`
  mutation createSession($token: String, $app: String){
    createSession(session: {token: $token app: $app}){
      success
      message
    }
  }
`
const RESET_USER_PASSWORD = gql`
  mutation resetUserConcesionarioPassword($username: String){
    resetUserConcesionarioPassword(username: $username){
      message
    }
  }
`
export default {
  name: 'CuiLogin',
  data: function () {
    return {
      form: this.$form.createForm(this),
      email: '',
      password: '',
      error: false,
      loading: false,
      newPasswordModal: false,
      acceptedTermsAndConditions: false,
      cognitoUser: null,
      confirmEmailModal: false,
      confirmationCode: '',
      usernameConfirm: '',
      newPassword: '',
      errorMessage: '',
      newPasswordAlert: '',
      confirmUserAlert: '',
      confirmUserError: '',
      sessionUserAttributes: '',
      newPasswordRequired: '',
      confirmationCodeRequired: '',
      newPasswordRequiredModal: false,
      loadingChangeRequired: false,
      emailRequiredModal: '',
      passwordHidden: false,
      passwordLoginHidden: false,
      resetPasswordModal: false,
      resetPasswordEmail: '',
    }
  },
  computed: {
    emailValidation() {
      return this.validEmail()
    },
  },
  beforeCreate() {
    // console.log(this.$cognito)
  },
  methods: {
    resetUserPassword() {
      this.$apollo.mutate({
        mutation: RESET_USER_PASSWORD,
        variables: {
          username: this.resetPasswordEmail,
        },
      })
        .then(data => {
          console.log(data)
          this.resetPasswordEmail = ''
          this.resetPasswordModal = false
          this.makeToast(true, 'success', 'Restablecer contraseña', 'Revisa tu bandeja de correo, te enviaremos un código de verificación para restablecer tu contraseña. Esto puede demorar varios minutos.')
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeAuthProvider(value) {
      this.$store.commit('CHANGE_SETTING', { setting: 'authProvider', value })
    },
    hidePassword() {
      this.passwordHidden = true
    },
    showPassword() {
      this.passwordHidden = false
    },
    showLoginPassword() {
      this.passwordLoginHidden = false
    },
    hideLoginPassword() {
      this.passwordLoginHidden = true
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$store.dispatch('user/LOGIN', { payload: values })
        }
      })
    },
    signin () {
      if (this.validateEmail(this.email) && this.validatePassword(this.password)) {
        this.loading = true
        console.log('Signin ==========================')
        this.$cognito.signin(this.email, this.password)
          .then(result => {
            console.log('Entro aqui')
            let jwt = ''
            let idToken = ''
            console.log(result)
            if (result.new_password_required) {
              this.cognitoUser = result.cognitoUser
              this.newPasswordModal = true
              this.loading = false
              this.password = ''
            } else {
              jwt = result.accessToken.jwtToken
              idToken = result.idToken.jwtToken
              this.$apollo.mutate({
                mutation: CREATE_SESSION,
                variables: {
                  token: jwt,
                  app: 'PCON',
                },
              })
                .then(data => {
                  console.log(data)
                  setTimeout(() => {
                    db.collection('consSession').doc(this.email).onSnapshot(document => {
                      console.log(document.data())
                      if (document.data() === undefined) {
                        this.$cognito.signout()
                        this.$store.dispatch('user/LOGOUT_COGNITO')
                      }
                    })
                  }, 1000)
                  this.$apollo.query({
                    query: GET_CONCESIONARIO_QUERY,
                    context: {
                      headers: { token: result.accessToken.jwtToken, app: 'PCON' },
                    },
                    variables: {
                      id: parseInt(result.idToken.payload['custom:concesionarioId']),
                    },
                  })
                    .then(({ data }) => {
                      // console.log(data)
                      // console.log(result)
                      this.$store.dispatch('user/LOAD_CURRENT_COGNITO_ACCOUNT', {
                        payload: { email: this.email, franchisee: result.idToken.payload['custom:concesionarioId'], rfc: data.getConcesionarioId.rfc, jwt: jwt, name: data.getConcesionarioId.name, idToken: idToken },
                      })
                      // var url = this.$route.query.redirect
                      this.loading = false
                      this.$cookies.set('acceptedTermsAndConditions', this.acceptedTermsAndConditions)
                      this.$router.replace('/')
                      // window.location.reload()
                    })
                    .catch(err => {
                      console.log(err)
                    })
                })
                .catch(error => {
                  console.log(error)
                })
              // console.log(jwt)
            }
          })
          .catch(err => {
            console.log(err)
            switch (err.code) {
              case 'UserNotConfirmedException':
                this.confirmEmailModal = true
                this.loading = false
                break
              case 'NotAuthorizedException':
                this.errorMessage = 'El correo electrónico o contraseña son incorrectos. Vuelve a intentarlo'
                break
              case 'PasswordResetRequiredException':
                this.makeToast(true, 'danger', 'Error', 'Se requiere cambio de contraseña.')
                break
              default:
                this.errorMessage = 'Error'
            }
            this.loading = false
          })
      } else {
        this.error = true
      }
    },
    invalidEmailFeedback() {
      return this.$t('El correo electrónico no es válido. Vuelve a intentarlo.')
    },
    validEmailFeedback(email) {
      return this.validateEmail(email) === true ? 'El correo electrónico es válido' : 'Inválido'
    },
    validateEmail(email) {
      var re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
      return email ? re.test(email) : null
    },
    validatePassword(password) {
      var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{8,}$/
      return password ? re.test(password) : null
    },
    validPasswordFeedback(password) {
      return this.validatePassword(password) === true ? 'La contraseña es válida.' : 'Inválido'
    },
    validateCode(code) {
      if (code.match(/^[0-9]+$/) && code.length === 6) {
        return true
      } else {
        return false
      }
    },
    validCodeFeedback(code) {
      if (code.match(/^[0-9]+$/) && code.length === 6) {
        return 'El código de autentificación es válido.'
      } else {
        return 'El código de autentificación no es válido. Vuelve a intentarlo.'
      }
    },
    invalidPasswordFeedback() {
      return this.$t('La contraseña no es válida. Vuelve a intentarlo. La contraseña debe tener 8 caracteres como mínimo. Incluye letras mayúsculas, letras minúsculas, números y caracteres especiales. ')
    },
    resetPassword() {
      this.cognitoUser.completeNewPasswordChallenge(this.newPassword, null, {
        onSuccess: (result) => {
          this.newPasswordAlert = 'Cambio de contraseña realizado'
          setTimeout(() => {
            this.newPasswordModal = false
            this.newPasswordAlert = ''
          }, 1500)
          this.loading = false
        },
        onFailure: (err) => {
          console.log('Error')
          console.log(err)
        },
      })
    },
    async resetPasswordRequired() {
      this.loadingChangeRequired = true
      await this.$apollo.mutate({
        mutation: gql`mutation confirmForgotConcesionarioPassword($username: String, $password: String, $confirmationCode: String) {
          confirmForgotConcesionarioPassword(
            username: $username
            password: $password
            confirmationCode: $confirmationCode
          ){
            message
          }
        }`,
        // context: headers(),
        variables: {
          username: this.emailRequiredModal,
          password: this.newPasswordRequired,
          confirmationCode: this.confirmationCodeRequired,
        },
      })
        .then(res => {
          this.makeToast(true, 'success', 'Cambio de contraseña correcto', 'La contraseña se ha cambiado correctamente.')
          this.newPasswordRequiredModal = false
          this.password = ''
          this.loadingChangeRequired = false
        })
        .catch(error => {
          if (error) {
            console.log(error)
            this.loadingChangeRequired = false
            this.makeToast(true, 'danger', 'Error', 'Ocurrió un error, verifica tus datos.')
          }
        })
    },
    userConfirmation() {
      this.$cognito.confirmation(this.usernameConfirm, this.confirmationCode)
        .then(result => {
          this.confirmUserAlert = 'Usuario confirmado'
          setTimeout(() => {
            this.confirmEmailModal = false
            this.confirmUserAlert = ''
          }, 1000)
        })
        .catch(error => {
          switch (error.code) {
            case 'CodeMismatchException':
              this.confirmUserError = error.message
              setTimeout(() => {
                this.confirmUserError = ''
              }, 3000)
              break
            default:
              this.confirmUserError = 'Error'
              setTimeout(() => {
                this.confirmUserError = ''
              }, 3000)
          }
        })
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: variant,
      })
    },
  },
  created() {
    this.acceptedTermsAndConditions = (this.$cookies.get('acceptedTermsAndConditions') === 'true')
  },
}
</script>
<style>
.space {
  height: 10px;
}
.display-eye {
  cursor:pointer;
}
</style>
